import React from 'react';
import { Investment } from '@/types/investment';
import InfoCard from '@/components/InfoCard';

interface DetailsProps {
  investment: Investment;
}

const NewDetails: React.FC<DetailsProps> = ({ investment }) => {
  const returnsItems = [
    { label: 'Management fee', value: investment.returns.managementFee },
    { 
      label: 'Target net ann\'l yield', 
      value: investment.id === 'jse-listed-index-linked-note' ? (
        <div className="mt-3">
          <table className="w-full text-sm border-collapse">
            <tbody>
              <tr className="border-b border-border/50">
                <td className="py-2 font-medium text-foreground w-16">Year 1</td>
                <td className="py-2 text-foreground">Guaranteed payback of 25% of Capital & 18.15% Return</td>
              </tr>
              <tr className="border-b border-border/50">
                <td className="py-2 font-medium text-foreground w-16">Year 3</td>
                <td className="py-2 text-foreground">Guaranteed payback of 25% of Capital & 36.30% Return</td>
              </tr>
              <tr>
                <td className="py-2 font-medium text-foreground w-16">Year 5</td>
                <td className="py-2 text-foreground">Growth linked to S&P 500</td>
              </tr>
            </tbody>
          </table>
        </div>
      ) : (
        <span className="text-primary font-semibold">{investment.returns.targetNetYield}</span>
      )
    },
  ];

  const scheduleItems = [
    { label: 'Subscription schedule', value: investment.schedule.subscription },
    { label: 'Payment schedule', value: investment.schedule.payment },
    { label: 'Interest type', value: investment.schedule.interestType },
    { label: 'Target term', value: investment.schedule.targetTerm },
  ];

  const structureItems = [
    { label: 'Tax document', value: investment.structure.taxDocument },
    { label: 'Offering structure', value: investment.structure.offeringType },
    { label: 'Ann\'l flat expense', value: `${investment.structure.annualFlatExpense}%` },
  ];

  return (
    <div>
      <h2 className="text-2xl font-semibold text-foreground mb-8">Details</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <InfoCard title="Returns & management fees" items={returnsItems} />
        <InfoCard title="Schedule" items={scheduleItems} />
        <InfoCard title="Structure" items={structureItems} />
      </div>
    </div>
  );
};

export default NewDetails;
